/* eslint-disable */
/*
  NOTE: thats a copy of react-phone-input-2 2.8.0 exclude flag.png
 */
!(function(t, e) {
  'object' == typeof exports && 'object' == typeof module
    ? (module.exports = e(require('react')))
    : 'function' == typeof define && define.amd
    ? define(['react'], e)
    : 'object' == typeof exports
    ? (exports.ReactPhoneInput = e(require('react')))
    : (t.ReactPhoneInput = e(t.React))
})(window, function(t) {
  return (function(t) {
    var e = {}
    function n(r) {
      if (e[r]) return e[r].exports
      var o = (e[r] = { i: r, l: !1, exports: {} })
      return t[r].call(o.exports, o, o.exports, n), (o.l = !0), o.exports
    }
    return (
      (n.m = t),
      (n.c = e),
      (n.d = function(t, e, r) {
        n.o(t, e) || Object.defineProperty(t, e, { enumerable: !0, get: r })
      }),
      (n.r = function(t) {
        'undefined' != typeof Symbol &&
          Symbol.toStringTag &&
          Object.defineProperty(t, Symbol.toStringTag, { value: 'Module' }),
          Object.defineProperty(t, '__esModule', { value: !0 })
      }),
      (n.t = function(t, e) {
        if ((1 & e && (t = n(t)), 8 & e)) return t
        if (4 & e && 'object' == typeof t && t && t.__esModule) return t
        var r = Object.create(null)
        if (
          (n.r(r),
          Object.defineProperty(r, 'default', { enumerable: !0, value: t }),
          2 & e && 'string' != typeof t)
        )
          for (var o in t)
            n.d(
              r,
              o,
              function(e) {
                return t[e]
              }.bind(null, o)
            )
        return r
      }),
      (n.n = function(t) {
        var e =
          t && t.__esModule
            ? function() {
                return t.default
              }
            : function() {
                return t
              }
        return n.d(e, 'a', e), e
      }),
      (n.o = function(t, e) {
        return Object.prototype.hasOwnProperty.call(t, e)
      }),
      (n.p = ''),
      n((n.s = 14))
    )
  })([
    function(e, n) {
      e.exports = t
    },
    function(t, e, n) {
      var r
      /*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
      /*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
      !(function() {
        'use strict'
        var n = {}.hasOwnProperty
        function o() {
          for (var t = [], e = 0; e < arguments.length; e++) {
            var r = arguments[e]
            if (r) {
              var a = typeof r
              if ('string' === a || 'number' === a) t.push(r)
              else if (Array.isArray(r) && r.length) {
                var i = o.apply(null, r)
                i && t.push(i)
              } else if ('object' === a) for (var u in r) n.call(r, u) && r[u] && t.push(u)
            }
          }
          return t.join(' ')
        }
        t.exports
          ? ((o.default = o), (t.exports = o))
          : void 0 ===
              (r = function() {
                return o
              }.apply(e, [])) || (t.exports = r)
      })()
    },
    function(t, e) {
      var n
      n = (function() {
        return this
      })()
      try {
        n = n || new Function('return this')()
      } catch (t) {
        'object' == typeof window && (n = window)
      }
      t.exports = n
    },
    function(t, e, n) {
      ;(function(e) {
        var n = 'Expected a function',
          r = '__lodash_hash_undefined__',
          o = '[object Function]',
          a = '[object GeneratorFunction]',
          i = /^\[object .+?Constructor\]$/,
          u = 'object' == typeof e && e && e.Object === Object && e,
          c = 'object' == typeof self && self && self.Object === Object && self,
          p = u || c || Function('return this')()
        var s,
          l = Array.prototype,
          f = Function.prototype,
          d = Object.prototype,
          b = p['__core-js_shared__'],
          g = (s = /[^.]+$/.exec((b && b.keys && b.keys.IE_PROTO) || ''))
            ? 'Symbol(src)_1.' + s
            : '',
          x = f.toString,
          h = d.hasOwnProperty,
          v = d.toString,
          y = RegExp(
            '^' +
              x
                .call(h)
                .replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
                .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') +
              '$'
          ),
          m = l.splice,
          k = F(p, 'Map'),
          C = F(Object, 'create')
        function w(t) {
          var e = -1,
            n = t ? t.length : 0
          for (this.clear(); ++e < n; ) {
            var r = t[e]
            this.set(r[0], r[1])
          }
        }
        function S(t) {
          var e = -1,
            n = t ? t.length : 0
          for (this.clear(); ++e < n; ) {
            var r = t[e]
            this.set(r[0], r[1])
          }
        }
        function j(t) {
          var e = -1,
            n = t ? t.length : 0
          for (this.clear(); ++e < n; ) {
            var r = t[e]
            this.set(r[0], r[1])
          }
        }
        function P(t, e) {
          for (var n, r, o = t.length; o--; )
            if ((n = t[o][0]) === (r = e) || (n != n && r != r)) return o
          return -1
        }
        function V(t) {
          return (
            !(!W(t) || ((e = t), g && g in e)) &&
            ((function(t) {
              var e = W(t) ? v.call(t) : ''
              return e == o || e == a
            })(t) ||
            (function(t) {
              var e = !1
              if (null != t && 'function' != typeof t.toString)
                try {
                  e = !!(t + '')
                } catch (t) {}
              return e
            })(t)
              ? y
              : i
            ).test(
              (function(t) {
                if (null != t) {
                  try {
                    return x.call(t)
                  } catch (t) {}
                  try {
                    return t + ''
                  } catch (t) {}
                }
                return ''
              })(t)
            )
          )
          var e
        }
        function z(t, e) {
          var n,
            r,
            o = t.__data__
          return ('string' == (r = typeof (n = e)) ||
          'number' == r ||
          'symbol' == r ||
          'boolean' == r
          ? '__proto__' !== n
          : null === n)
            ? o['string' == typeof e ? 'string' : 'hash']
            : o.map
        }
        function F(t, e) {
          var n = (function(t, e) {
            return null == t ? void 0 : t[e]
          })(t, e)
          return V(n) ? n : void 0
        }
        function K(t, e) {
          if ('function' != typeof t || (e && 'function' != typeof e)) throw new TypeError(n)
          var r = function() {
            var n = arguments,
              o = e ? e.apply(this, n) : n[0],
              a = r.cache
            if (a.has(o)) return a.get(o)
            var i = t.apply(this, n)
            return (r.cache = a.set(o, i)), i
          }
          return (r.cache = new (K.Cache || j)()), r
        }
        function W(t) {
          var e = typeof t
          return !!t && ('object' == e || 'function' == e)
        }
        ;(w.prototype.clear = function() {
          this.__data__ = C ? C(null) : {}
        }),
          (w.prototype.delete = function(t) {
            return this.has(t) && delete this.__data__[t]
          }),
          (w.prototype.get = function(t) {
            var e = this.__data__
            if (C) {
              var n = e[t]
              return n === r ? void 0 : n
            }
            return h.call(e, t) ? e[t] : void 0
          }),
          (w.prototype.has = function(t) {
            var e = this.__data__
            return C ? void 0 !== e[t] : h.call(e, t)
          }),
          (w.prototype.set = function(t, e) {
            return (this.__data__[t] = C && void 0 === e ? r : e), this
          }),
          (S.prototype.clear = function() {
            this.__data__ = []
          }),
          (S.prototype.delete = function(t) {
            var e = this.__data__,
              n = P(e, t)
            return !(n < 0 || (n == e.length - 1 ? e.pop() : m.call(e, n, 1), 0))
          }),
          (S.prototype.get = function(t) {
            var e = this.__data__,
              n = P(e, t)
            return n < 0 ? void 0 : e[n][1]
          }),
          (S.prototype.has = function(t) {
            return P(this.__data__, t) > -1
          }),
          (S.prototype.set = function(t, e) {
            var n = this.__data__,
              r = P(n, t)
            return r < 0 ? n.push([t, e]) : (n[r][1] = e), this
          }),
          (j.prototype.clear = function() {
            this.__data__ = { hash: new w(), map: new (k || S)(), string: new w() }
          }),
          (j.prototype.delete = function(t) {
            return z(this, t).delete(t)
          }),
          (j.prototype.get = function(t) {
            return z(this, t).get(t)
          }),
          (j.prototype.has = function(t) {
            return z(this, t).has(t)
          }),
          (j.prototype.set = function(t, e) {
            return z(this, t).set(t, e), this
          }),
          (K.Cache = j),
          (t.exports = K)
      }.call(this, n(2)))
    },
    function(t, e, n) {
      ;(function(e) {
        var n = 'Expected a function',
          r = NaN,
          o = '[object Symbol]',
          a = /^\s+|\s+$/g,
          i = /^[-+]0x[0-9a-f]+$/i,
          u = /^0b[01]+$/i,
          c = /^0o[0-7]+$/i,
          p = parseInt,
          s = 'object' == typeof e && e && e.Object === Object && e,
          l = 'object' == typeof self && self && self.Object === Object && self,
          f = s || l || Function('return this')(),
          d = Object.prototype.toString,
          b = Math.max,
          g = Math.min,
          x = function() {
            return f.Date.now()
          }
        function h(t) {
          var e = typeof t
          return !!t && ('object' == e || 'function' == e)
        }
        function v(t) {
          if ('number' == typeof t) return t
          if (
            (function(t) {
              return (
                'symbol' == typeof t ||
                ((function(t) {
                  return !!t && 'object' == typeof t
                })(t) &&
                  d.call(t) == o)
              )
            })(t)
          )
            return r
          if (h(t)) {
            var e = 'function' == typeof t.valueOf ? t.valueOf() : t
            t = h(e) ? e + '' : e
          }
          if ('string' != typeof t) return 0 === t ? t : +t
          t = t.replace(a, '')
          var n = u.test(t)
          return n || c.test(t) ? p(t.slice(2), n ? 2 : 8) : i.test(t) ? r : +t
        }
        t.exports = function(t, e, r) {
          var o,
            a,
            i,
            u,
            c,
            p,
            s = 0,
            l = !1,
            f = !1,
            d = !0
          if ('function' != typeof t) throw new TypeError(n)
          function y(e) {
            var n = o,
              r = a
            return (o = a = void 0), (s = e), (u = t.apply(r, n))
          }
          function m(t) {
            var n = t - p
            return void 0 === p || n >= e || n < 0 || (f && t - s >= i)
          }
          function k() {
            var t = x()
            if (m(t)) return C(t)
            c = setTimeout(
              k,
              (function(t) {
                var n = e - (t - p)
                return f ? g(n, i - (t - s)) : n
              })(t)
            )
          }
          function C(t) {
            return (c = void 0), d && o ? y(t) : ((o = a = void 0), u)
          }
          function w() {
            var t = x(),
              n = m(t)
            if (((o = arguments), (a = this), (p = t), n)) {
              if (void 0 === c)
                return (function(t) {
                  return (s = t), (c = setTimeout(k, e)), l ? y(t) : u
                })(p)
              if (f) return (c = setTimeout(k, e)), y(p)
            }
            return void 0 === c && (c = setTimeout(k, e)), u
          }
          return (
            (e = v(e) || 0),
            h(r) &&
              ((l = !!r.leading),
              (i = (f = 'maxWait' in r) ? b(v(r.maxWait) || 0, e) : i),
              (d = 'trailing' in r ? !!r.trailing : d)),
            (w.cancel = function() {
              void 0 !== c && clearTimeout(c), (s = 0), (o = p = a = c = void 0)
            }),
            (w.flush = function() {
              return void 0 === c ? u : C(x())
            }),
            w
          )
        }
      }.call(this, n(2)))
    },
    function(t, e, n) {
      ;(function(t, n) {
        var r = 200,
          o = 'Expected a function',
          a = '__lodash_hash_undefined__',
          i = 1,
          u = 2,
          c = 1 / 0,
          p = 9007199254740991,
          s = '[object Arguments]',
          l = '[object Array]',
          f = '[object Boolean]',
          d = '[object Date]',
          b = '[object Error]',
          g = '[object Function]',
          x = '[object GeneratorFunction]',
          h = '[object Map]',
          v = '[object Number]',
          y = '[object Object]',
          m = '[object RegExp]',
          k = '[object Set]',
          C = '[object String]',
          w = '[object Symbol]',
          S = '[object ArrayBuffer]',
          j = '[object DataView]',
          P = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
          V = /^\w*$/,
          z = /^\./,
          F = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
          K = /\\(\\)?/g,
          W = /^\[object .+?Constructor\]$/,
          U = /^(?:0|[1-9]\d*)$/,
          D = {}
        ;(D['[object Float32Array]'] = D['[object Float64Array]'] = D['[object Int8Array]'] = D[
          '[object Int16Array]'
        ] = D['[object Int32Array]'] = D['[object Uint8Array]'] = D[
          '[object Uint8ClampedArray]'
        ] = D['[object Uint16Array]'] = D['[object Uint32Array]'] = !0),
          (D[s] = D[l] = D[S] = D[f] = D[j] = D[d] = D[b] = D[g] = D[h] = D[v] = D[y] = D[m] = D[
            k
          ] = D[C] = D['[object WeakMap]'] = !1)
        var O = 'object' == typeof t && t && t.Object === Object && t,
          H = 'object' == typeof self && self && self.Object === Object && self,
          N = O || H || Function('return this')(),
          Y = e && !e.nodeType && e,
          R = Y && 'object' == typeof n && n && !n.nodeType && n,
          L = R && R.exports === Y && O.process,
          A = (function() {
            try {
              return L && L.binding('util')
            } catch (t) {}
          })(),
          X = A && A.isTypedArray
        function M(t, e, n, r) {
          var o = -1,
            a = t ? t.length : 0
          for (r && a && (n = t[++o]); ++o < a; ) n = e(n, t[o], o, t)
          return n
        }
        function I(t, e) {
          for (var n = -1, r = t ? t.length : 0; ++n < r; ) if (e(t[n], n, t)) return !0
          return !1
        }
        function E(t, e, n, r, o) {
          return (
            o(t, function(t, o, a) {
              n = r ? ((r = !1), t) : e(n, t, o, a)
            }),
            n
          )
        }
        function G(t) {
          var e = !1
          if (null != t && 'function' != typeof t.toString)
            try {
              e = !!(t + '')
            } catch (t) {}
          return e
        }
        function J(t) {
          var e = -1,
            n = Array(t.size)
          return (
            t.forEach(function(t, r) {
              n[++e] = [r, t]
            }),
            n
          )
        }
        function Z(t) {
          var e = -1,
            n = Array(t.size)
          return (
            t.forEach(function(t) {
              n[++e] = t
            }),
            n
          )
        }
        var B,
          T,
          q,
          Q = Array.prototype,
          _ = Function.prototype,
          $ = Object.prototype,
          tt = N['__core-js_shared__'],
          et = (B = /[^.]+$/.exec((tt && tt.keys && tt.keys.IE_PROTO) || ''))
            ? 'Symbol(src)_1.' + B
            : '',
          nt = _.toString,
          rt = $.hasOwnProperty,
          ot = $.toString,
          at = RegExp(
            '^' +
              nt
                .call(rt)
                .replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
                .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') +
              '$'
          ),
          it = N.Symbol,
          ut = N.Uint8Array,
          ct = $.propertyIsEnumerable,
          pt = Q.splice,
          st =
            ((T = Object.keys),
            (q = Object),
            function(t) {
              return T(q(t))
            }),
          lt = Gt(N, 'DataView'),
          ft = Gt(N, 'Map'),
          dt = Gt(N, 'Promise'),
          bt = Gt(N, 'Set'),
          gt = Gt(N, 'WeakMap'),
          xt = Gt(Object, 'create'),
          ht = $t(lt),
          vt = $t(ft),
          yt = $t(dt),
          mt = $t(bt),
          kt = $t(gt),
          Ct = it ? it.prototype : void 0,
          wt = Ct ? Ct.valueOf : void 0,
          St = Ct ? Ct.toString : void 0
        function jt(t) {
          var e = -1,
            n = t ? t.length : 0
          for (this.clear(); ++e < n; ) {
            var r = t[e]
            this.set(r[0], r[1])
          }
        }
        function Pt(t) {
          var e = -1,
            n = t ? t.length : 0
          for (this.clear(); ++e < n; ) {
            var r = t[e]
            this.set(r[0], r[1])
          }
        }
        function Vt(t) {
          var e = -1,
            n = t ? t.length : 0
          for (this.clear(); ++e < n; ) {
            var r = t[e]
            this.set(r[0], r[1])
          }
        }
        function zt(t) {
          var e = -1,
            n = t ? t.length : 0
          for (this.__data__ = new Vt(); ++e < n; ) this.add(t[e])
        }
        function Ft(t) {
          this.__data__ = new Pt(t)
        }
        function Kt(t, e) {
          var n =
              re(t) || ne(t)
                ? (function(t, e) {
                    for (var n = -1, r = Array(t); ++n < t; ) r[n] = e(n)
                    return r
                  })(t.length, String)
                : [],
            r = n.length,
            o = !!r
          for (var a in t) (!e && !rt.call(t, a)) || (o && ('length' == a || Zt(a, r))) || n.push(a)
          return n
        }
        function Wt(t, e) {
          for (var n = t.length; n--; ) if (ee(t[n][0], e)) return n
          return -1
        }
        ;(jt.prototype.clear = function() {
          this.__data__ = xt ? xt(null) : {}
        }),
          (jt.prototype.delete = function(t) {
            return this.has(t) && delete this.__data__[t]
          }),
          (jt.prototype.get = function(t) {
            var e = this.__data__
            if (xt) {
              var n = e[t]
              return n === a ? void 0 : n
            }
            return rt.call(e, t) ? e[t] : void 0
          }),
          (jt.prototype.has = function(t) {
            var e = this.__data__
            return xt ? void 0 !== e[t] : rt.call(e, t)
          }),
          (jt.prototype.set = function(t, e) {
            return (this.__data__[t] = xt && void 0 === e ? a : e), this
          }),
          (Pt.prototype.clear = function() {
            this.__data__ = []
          }),
          (Pt.prototype.delete = function(t) {
            var e = this.__data__,
              n = Wt(e, t)
            return !(n < 0 || (n == e.length - 1 ? e.pop() : pt.call(e, n, 1), 0))
          }),
          (Pt.prototype.get = function(t) {
            var e = this.__data__,
              n = Wt(e, t)
            return n < 0 ? void 0 : e[n][1]
          }),
          (Pt.prototype.has = function(t) {
            return Wt(this.__data__, t) > -1
          }),
          (Pt.prototype.set = function(t, e) {
            var n = this.__data__,
              r = Wt(n, t)
            return r < 0 ? n.push([t, e]) : (n[r][1] = e), this
          }),
          (Vt.prototype.clear = function() {
            this.__data__ = { hash: new jt(), map: new (ft || Pt)(), string: new jt() }
          }),
          (Vt.prototype.delete = function(t) {
            return Et(this, t).delete(t)
          }),
          (Vt.prototype.get = function(t) {
            return Et(this, t).get(t)
          }),
          (Vt.prototype.has = function(t) {
            return Et(this, t).has(t)
          }),
          (Vt.prototype.set = function(t, e) {
            return Et(this, t).set(t, e), this
          }),
          (zt.prototype.add = zt.prototype.push = function(t) {
            return this.__data__.set(t, a), this
          }),
          (zt.prototype.has = function(t) {
            return this.__data__.has(t)
          }),
          (Ft.prototype.clear = function() {
            this.__data__ = new Pt()
          }),
          (Ft.prototype.delete = function(t) {
            return this.__data__.delete(t)
          }),
          (Ft.prototype.get = function(t) {
            return this.__data__.get(t)
          }),
          (Ft.prototype.has = function(t) {
            return this.__data__.has(t)
          }),
          (Ft.prototype.set = function(t, e) {
            var n = this.__data__
            if (n instanceof Pt) {
              var o = n.__data__
              if (!ft || o.length < r - 1) return o.push([t, e]), this
              n = this.__data__ = new Vt(o)
            }
            return n.set(t, e), this
          })
        var Ut,
          Dt,
          Ot =
            ((Ut = function(t, e) {
              return t && Ht(t, e, le)
            }),
            function(t, e) {
              if (null == t) return t
              if (!oe(t)) return Ut(t, e)
              for (
                var n = t.length, r = Dt ? n : -1, o = Object(t);
                (Dt ? r-- : ++r < n) && !1 !== e(o[r], r, o);

              );
              return t
            }),
          Ht = (function(t) {
            return function(e, n, r) {
              for (var o = -1, a = Object(e), i = r(e), u = i.length; u--; ) {
                var c = i[t ? u : ++o]
                if (!1 === n(a[c], c, a)) break
              }
              return e
            }
          })()
        function Nt(t, e) {
          for (var n = 0, r = (e = Bt(e, t) ? [e] : Mt(e)).length; null != t && n < r; )
            t = t[_t(e[n++])]
          return n && n == r ? t : void 0
        }
        function Yt(t, e) {
          return null != t && e in Object(t)
        }
        function Rt(t, e, n, r, o) {
          return (
            t === e ||
            (null == t || null == e || (!ue(t) && !ce(e))
              ? t != t && e != e
              : (function(t, e, n, r, o, a) {
                  var c = re(t),
                    p = re(e),
                    g = l,
                    x = l
                  c || (g = (g = Jt(t)) == s ? y : g)
                  p || (x = (x = Jt(e)) == s ? y : x)
                  var P = g == y && !G(t),
                    V = x == y && !G(e),
                    z = g == x
                  if (z && !P)
                    return (
                      a || (a = new Ft()),
                      c || se(t)
                        ? It(t, e, n, r, o, a)
                        : (function(t, e, n, r, o, a, c) {
                            switch (n) {
                              case j:
                                if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset)
                                  return !1
                                ;(t = t.buffer), (e = e.buffer)
                              case S:
                                return !(t.byteLength != e.byteLength || !r(new ut(t), new ut(e)))
                              case f:
                              case d:
                              case v:
                                return ee(+t, +e)
                              case b:
                                return t.name == e.name && t.message == e.message
                              case m:
                              case C:
                                return t == e + ''
                              case h:
                                var p = J
                              case k:
                                var s = a & u
                                if ((p || (p = Z), t.size != e.size && !s)) return !1
                                var l = c.get(t)
                                if (l) return l == e
                                ;(a |= i), c.set(t, e)
                                var g = It(p(t), p(e), r, o, a, c)
                                return c.delete(t), g
                              case w:
                                if (wt) return wt.call(t) == wt.call(e)
                            }
                            return !1
                          })(t, e, g, n, r, o, a)
                    )
                  if (!(o & u)) {
                    var F = P && rt.call(t, '__wrapped__'),
                      K = V && rt.call(e, '__wrapped__')
                    if (F || K) {
                      var W = F ? t.value() : t,
                        U = K ? e.value() : e
                      return a || (a = new Ft()), n(W, U, r, o, a)
                    }
                  }
                  if (!z) return !1
                  return (
                    a || (a = new Ft()),
                    (function(t, e, n, r, o, a) {
                      var i = o & u,
                        c = le(t),
                        p = c.length,
                        s = le(e).length
                      if (p != s && !i) return !1
                      for (var l = p; l--; ) {
                        var f = c[l]
                        if (!(i ? f in e : rt.call(e, f))) return !1
                      }
                      var d = a.get(t)
                      if (d && a.get(e)) return d == e
                      var b = !0
                      a.set(t, e), a.set(e, t)
                      for (var g = i; ++l < p; ) {
                        f = c[l]
                        var x = t[f],
                          h = e[f]
                        if (r) var v = i ? r(h, x, f, e, t, a) : r(x, h, f, t, e, a)
                        if (!(void 0 === v ? x === h || n(x, h, r, o, a) : v)) {
                          b = !1
                          break
                        }
                        g || (g = 'constructor' == f)
                      }
                      if (b && !g) {
                        var y = t.constructor,
                          m = e.constructor
                        y != m &&
                          'constructor' in t &&
                          'constructor' in e &&
                          !(
                            'function' == typeof y &&
                            y instanceof y &&
                            'function' == typeof m &&
                            m instanceof m
                          ) &&
                          (b = !1)
                      }
                      return a.delete(t), a.delete(e), b
                    })(t, e, n, r, o, a)
                  )
                })(t, e, Rt, n, r, o))
          )
        }
        function Lt(t) {
          return !(!ue(t) || ((e = t), et && et in e)) && (ae(t) || G(t) ? at : W).test($t(t))
          var e
        }
        function At(t) {
          return 'function' == typeof t
            ? t
            : null == t
            ? fe
            : 'object' == typeof t
            ? re(t)
              ? (function(t, e) {
                  if (Bt(t) && Tt(e)) return qt(_t(t), e)
                  return function(n) {
                    var r = (function(t, e, n) {
                      var r = null == t ? void 0 : Nt(t, e)
                      return void 0 === r ? n : r
                    })(n, t)
                    return void 0 === r && r === e
                      ? (function(t, e) {
                          return (
                            null != t &&
                            (function(t, e, n) {
                              e = Bt(e, t) ? [e] : Mt(e)
                              var r,
                                o = -1,
                                a = e.length
                              for (; ++o < a; ) {
                                var i = _t(e[o])
                                if (!(r = null != t && n(t, i))) break
                                t = t[i]
                              }
                              if (r) return r
                              return (
                                !!(a = t ? t.length : 0) && ie(a) && Zt(i, a) && (re(t) || ne(t))
                              )
                            })(t, e, Yt)
                          )
                        })(n, t)
                      : Rt(e, r, void 0, i | u)
                  }
                })(t[0], t[1])
              : (function(t) {
                  var e = (function(t) {
                    var e = le(t),
                      n = e.length
                    for (; n--; ) {
                      var r = e[n],
                        o = t[r]
                      e[n] = [r, o, Tt(o)]
                    }
                    return e
                  })(t)
                  if (1 == e.length && e[0][2]) return qt(e[0][0], e[0][1])
                  return function(n) {
                    return (
                      n === t ||
                      (function(t, e, n, r) {
                        var o = n.length,
                          a = o,
                          c = !r
                        if (null == t) return !a
                        for (t = Object(t); o--; ) {
                          var p = n[o]
                          if (c && p[2] ? p[1] !== t[p[0]] : !(p[0] in t)) return !1
                        }
                        for (; ++o < a; ) {
                          var s = (p = n[o])[0],
                            l = t[s],
                            f = p[1]
                          if (c && p[2]) {
                            if (void 0 === l && !(s in t)) return !1
                          } else {
                            var d = new Ft()
                            if (r) var b = r(l, f, s, t, e, d)
                            if (!(void 0 === b ? Rt(f, l, r, i | u, d) : b)) return !1
                          }
                        }
                        return !0
                      })(n, t, e)
                    )
                  }
                })(t)
            : Bt((e = t))
            ? ((n = _t(e)),
              function(t) {
                return null == t ? void 0 : t[n]
              })
            : (function(t) {
                return function(e) {
                  return Nt(e, t)
                }
              })(e)
          var e, n
        }
        function Xt(t) {
          if (
            ((n = (e = t) && e.constructor),
            (r = ('function' == typeof n && n.prototype) || $),
            e !== r)
          )
            return st(t)
          var e,
            n,
            r,
            o = []
          for (var a in Object(t)) rt.call(t, a) && 'constructor' != a && o.push(a)
          return o
        }
        function Mt(t) {
          return re(t) ? t : Qt(t)
        }
        function It(t, e, n, r, o, a) {
          var c = o & u,
            p = t.length,
            s = e.length
          if (p != s && !(c && s > p)) return !1
          var l = a.get(t)
          if (l && a.get(e)) return l == e
          var f = -1,
            d = !0,
            b = o & i ? new zt() : void 0
          for (a.set(t, e), a.set(e, t); ++f < p; ) {
            var g = t[f],
              x = e[f]
            if (r) var h = c ? r(x, g, f, e, t, a) : r(g, x, f, t, e, a)
            if (void 0 !== h) {
              if (h) continue
              d = !1
              break
            }
            if (b) {
              if (
                !I(e, function(t, e) {
                  if (!b.has(e) && (g === t || n(g, t, r, o, a))) return b.add(e)
                })
              ) {
                d = !1
                break
              }
            } else if (g !== x && !n(g, x, r, o, a)) {
              d = !1
              break
            }
          }
          return a.delete(t), a.delete(e), d
        }
        function Et(t, e) {
          var n,
            r,
            o = t.__data__
          return ('string' == (r = typeof (n = e)) ||
          'number' == r ||
          'symbol' == r ||
          'boolean' == r
          ? '__proto__' !== n
          : null === n)
            ? o['string' == typeof e ? 'string' : 'hash']
            : o.map
        }
        function Gt(t, e) {
          var n = (function(t, e) {
            return null == t ? void 0 : t[e]
          })(t, e)
          return Lt(n) ? n : void 0
        }
        var Jt = function(t) {
          return ot.call(t)
        }
        function Zt(t, e) {
          return (
            !!(e = null == e ? p : e) &&
            ('number' == typeof t || U.test(t)) &&
            t > -1 &&
            t % 1 == 0 &&
            t < e
          )
        }
        function Bt(t, e) {
          if (re(t)) return !1
          var n = typeof t
          return (
            !('number' != n && 'symbol' != n && 'boolean' != n && null != t && !pe(t)) ||
            V.test(t) || !P.test(t) || (null != e && t in Object(e))
          )
        }
        function Tt(t) {
          return t == t && !ue(t)
        }
        function qt(t, e) {
          return function(n) {
            return null != n && n[t] === e && (void 0 !== e || t in Object(n))
          }
        }
        ;((lt && Jt(new lt(new ArrayBuffer(1))) != j) ||
          (ft && Jt(new ft()) != h) ||
          (dt && '[object Promise]' != Jt(dt.resolve())) ||
          (bt && Jt(new bt()) != k) ||
          (gt && '[object WeakMap]' != Jt(new gt()))) &&
          (Jt = function(t) {
            var e = ot.call(t),
              n = e == y ? t.constructor : void 0,
              r = n ? $t(n) : void 0
            if (r)
              switch (r) {
                case ht:
                  return j
                case vt:
                  return h
                case yt:
                  return '[object Promise]'
                case mt:
                  return k
                case kt:
                  return '[object WeakMap]'
              }
            return e
          })
        var Qt = te(function(t) {
          var e
          t =
            null == (e = t)
              ? ''
              : (function(t) {
                  if ('string' == typeof t) return t
                  if (pe(t)) return St ? St.call(t) : ''
                  var e = t + ''
                  return '0' == e && 1 / t == -c ? '-0' : e
                })(e)
          var n = []
          return (
            z.test(t) && n.push(''),
            t.replace(F, function(t, e, r, o) {
              n.push(r ? o.replace(K, '$1') : e || t)
            }),
            n
          )
        })
        function _t(t) {
          if ('string' == typeof t || pe(t)) return t
          var e = t + ''
          return '0' == e && 1 / t == -c ? '-0' : e
        }
        function $t(t) {
          if (null != t) {
            try {
              return nt.call(t)
            } catch (t) {}
            try {
              return t + ''
            } catch (t) {}
          }
          return ''
        }
        function te(t, e) {
          if ('function' != typeof t || (e && 'function' != typeof e)) throw new TypeError(o)
          var n = function() {
            var r = arguments,
              o = e ? e.apply(this, r) : r[0],
              a = n.cache
            if (a.has(o)) return a.get(o)
            var i = t.apply(this, r)
            return (n.cache = a.set(o, i)), i
          }
          return (n.cache = new (te.Cache || Vt)()), n
        }
        function ee(t, e) {
          return t === e || (t != t && e != e)
        }
        function ne(t) {
          return (
            (function(t) {
              return ce(t) && oe(t)
            })(t) &&
            rt.call(t, 'callee') &&
            (!ct.call(t, 'callee') || ot.call(t) == s)
          )
        }
        te.Cache = Vt
        var re = Array.isArray
        function oe(t) {
          return null != t && ie(t.length) && !ae(t)
        }
        function ae(t) {
          var e = ue(t) ? ot.call(t) : ''
          return e == g || e == x
        }
        function ie(t) {
          return 'number' == typeof t && t > -1 && t % 1 == 0 && t <= p
        }
        function ue(t) {
          var e = typeof t
          return !!t && ('object' == e || 'function' == e)
        }
        function ce(t) {
          return !!t && 'object' == typeof t
        }
        function pe(t) {
          return 'symbol' == typeof t || (ce(t) && ot.call(t) == w)
        }
        var se = X
          ? (function(t) {
              return function(e) {
                return t(e)
              }
            })(X)
          : function(t) {
              return ce(t) && ie(t.length) && !!D[ot.call(t)]
            }
        function le(t) {
          return oe(t) ? Kt(t) : Xt(t)
        }
        function fe(t) {
          return t
        }
        n.exports = function(t, e, n) {
          var r = re(t) ? M : E,
            o = arguments.length < 3
          return r(t, At(e), n, o, Ot)
        }
      }.call(this, n(2), n(6)(t)))
    },
    function(t, e) {
      t.exports = function(t) {
        return (
          t.webpackPolyfill ||
            ((t.deprecate = function() {}),
            (t.paths = []),
            t.children || (t.children = []),
            Object.defineProperty(t, 'loaded', {
              enumerable: !0,
              get: function() {
                return t.l
              },
            }),
            Object.defineProperty(t, 'id', {
              enumerable: !0,
              get: function() {
                return t.i
              },
            }),
            (t.webpackPolyfill = 1)),
          t
        )
      }
    },
    function(t, e, n) {
      var r = n(8)
      'string' == typeof r && (r = [[t.i, r, '']])
      var o = { hmr: !0, transform: void 0, insertInto: void 0 }
      n(12)(r, o)
      r.locals && (t.exports = r.locals)
    },
    function(t, e, n) {
      e = t.exports = n(9)(!1)
      var r = n(10)(n(11))
      e.push([t.i, '', ''])
    },
    function(t, e, n) {
      'use strict'
      t.exports = function(t) {
        var e = []
        return (
          (e.toString = function() {
            return this.map(function(e) {
              var n = (function(t, e) {
                var n = t[1] || '',
                  r = t[3]
                if (!r) return n
                if (e && 'function' == typeof btoa) {
                  var o =
                      ((i = r),
                      '/*# sourceMappingURL=data:application/json;charset=utf-8;base64,' +
                        btoa(unescape(encodeURIComponent(JSON.stringify(i)))) +
                        ' */'),
                    a = r.sources.map(function(t) {
                      return '/*# sourceURL=' + r.sourceRoot + t + ' */'
                    })
                  return [n]
                    .concat(a)
                    .concat([o])
                    .join('\n')
                }
                var i
                return [n].join('\n')
              })(e, t)
              return e[2] ? '@media ' + e[2] + '{' + n + '}' : n
            }).join('')
          }),
          (e.i = function(t, n) {
            'string' == typeof t && (t = [[null, t, '']])
            for (var r = {}, o = 0; o < this.length; o++) {
              var a = this[o][0]
              null != a && (r[a] = !0)
            }
            for (o = 0; o < t.length; o++) {
              var i = t[o]
              ;(null != i[0] && r[i[0]]) ||
                (n && !i[2] ? (i[2] = n) : n && (i[2] = '(' + i[2] + ') and (' + n + ')'),
                e.push(i))
            }
          }),
          e
        )
      }
    },
    function(t, e, n) {
      'use strict'
      t.exports = function(t, e) {
        return 'string' != typeof t
          ? t
          : (/^['"].*['"]$/.test(t) && (t = t.slice(1, -1)),
            /["'() \t\n]/.test(t) || e
              ? '"' + t.replace(/"/g, '\\"').replace(/\n/g, '\\n') + '"'
              : t)
      }
    },
    function(t, e) {
      t.exports = ''
    },
    function(t, e, n) {
      var r,
        o,
        a = {},
        i =
          ((r = function() {
            return window && document && document.all && !window.atob
          }),
          function() {
            return void 0 === o && (o = r.apply(this, arguments)), o
          }),
        u = (function(t) {
          var e = {}
          return function(t, n) {
            if ('function' == typeof t) return t()
            if (void 0 === e[t]) {
              var r = function(t, e) {
                return e ? e.querySelector(t) : document.querySelector(t)
              }.call(this, t, n)
              if (window.HTMLIFrameElement && r instanceof window.HTMLIFrameElement)
                try {
                  r = r.contentDocument.head
                } catch (t) {
                  r = null
                }
              e[t] = r
            }
            return e[t]
          }
        })(),
        c = null,
        p = 0,
        s = [],
        l = n(13)
      function f(t, e) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n],
            o = a[r.id]
          if (o) {
            o.refs++
            for (var i = 0; i < o.parts.length; i++) o.parts[i](r.parts[i])
            for (; i < r.parts.length; i++) o.parts.push(v(r.parts[i], e))
          } else {
            var u = []
            for (i = 0; i < r.parts.length; i++) u.push(v(r.parts[i], e))
            a[r.id] = { id: r.id, refs: 1, parts: u }
          }
        }
      }
      function d(t, e) {
        for (var n = [], r = {}, o = 0; o < t.length; o++) {
          var a = t[o],
            i = e.base ? a[0] + e.base : a[0],
            u = { css: a[1], media: a[2], sourceMap: a[3] }
          r[i] ? r[i].parts.push(u) : n.push((r[i] = { id: i, parts: [u] }))
        }
        return n
      }
      function b(t, e) {
        // var n = u(t.insertInto)
        // if (!n)
        //   throw new Error(
        //     "Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid."
        //   )
        // var r = s[s.length - 1]
        // if ('top' === t.insertAt)
        //   r
        //     ? r.nextSibling
        //       ? n.insertBefore(e, r.nextSibling)
        //       : n.appendChild(e)
        //     : n.insertBefore(e, n.firstChild),
        //     s.push(e)
        // else if ('bottom' === t.insertAt) n.appendChild(e)
        // else {
        //   if ('object' != typeof t.insertAt || !t.insertAt.before)
        //     throw new Error(
        //       "[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n"
        //     )
        //   var o = u(t.insertAt.before, n)
        //   n.insertBefore(e, o)
        // }
      }
      function g(t) {
        if (null === t.parentNode) return !1
        t.parentNode.removeChild(t)
        var e = s.indexOf(t)
        e >= 0 && s.splice(e, 1)
      }
      function x(t) {
        var e = document.createElement('style')
        if ((void 0 === t.attrs.type && (t.attrs.type = 'text/css'), void 0 === t.attrs.nonce)) {
          var r = (function() {
            0
            return n.nc
          })()
          r && (t.attrs.nonce = r)
        }
        return h(e, t.attrs), b(t, e), e
      }
      function h(t, e) {
        Object.keys(e).forEach(function(n) {
          t.setAttribute(n, e[n])
        })
      }
      function v(t, e) {
        var n, r, o, a
        if (e.transform && t.css) {
          if (
            !(a =
              'function' == typeof e.transform ? e.transform(t.css) : e.transform.default(t.css))
          )
            return function() {}
          t.css = a
        }
        if (e.singleton) {
          var i = p++
          ;(n = c || (c = x(e))), (r = k.bind(null, n, i, !1)), (o = k.bind(null, n, i, !0))
        } else
          t.sourceMap &&
          'function' == typeof URL &&
          'function' == typeof URL.createObjectURL &&
          'function' == typeof URL.revokeObjectURL &&
          'function' == typeof Blob &&
          'function' == typeof btoa
            ? ((n = (function(t) {
                var e = document.createElement('link')
                return (
                  void 0 === t.attrs.type && (t.attrs.type = 'text/css'),
                  (t.attrs.rel = 'stylesheet'),
                  h(e, t.attrs),
                  b(t, e),
                  e
                )
              })(e)),
              (r = function(t, e, n) {
                var r = n.css,
                  o = n.sourceMap,
                  a = void 0 === e.convertToAbsoluteUrls && o
                ;(e.convertToAbsoluteUrls || a) && (r = l(r))
                o &&
                  (r +=
                    '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(o)))) +
                    ' */')
                var i = new Blob([r], { type: 'text/css' }),
                  u = t.href
                ;(t.href = URL.createObjectURL(i)), u && URL.revokeObjectURL(u)
              }.bind(null, n, e)),
              (o = function() {
                g(n), n.href && URL.revokeObjectURL(n.href)
              }))
            : ((n = x(e)),
              (r = function(t, e) {
                var n = e.css,
                  r = e.media
                r && t.setAttribute('media', r)
                if (t.styleSheet) t.styleSheet.cssText = n
                else {
                  for (; t.firstChild; ) t.removeChild(t.firstChild)
                  t.appendChild(document.createTextNode(n))
                }
              }.bind(null, n)),
              (o = function() {
                g(n)
              }))
        return (
          r(t),
          function(e) {
            if (e) {
              if (e.css === t.css && e.media === t.media && e.sourceMap === t.sourceMap) return
              r((t = e))
            } else o()
          }
        )
      }
      t.exports = function(t, e) {
        if ('undefined' != typeof DEBUG && DEBUG && 'object' != typeof document)
          throw new Error('The style-loader cannot be used in a non-browser environment')
        ;((e = e || {}).attrs = 'object' == typeof e.attrs ? e.attrs : {}),
          e.singleton || 'boolean' == typeof e.singleton || (e.singleton = i()),
          e.insertInto || (e.insertInto = 'head'),
          e.insertAt || (e.insertAt = 'bottom')
        var n = d(t, e)
        return (
          f(n, e),
          function(t) {
            for (var r = [], o = 0; o < n.length; o++) {
              var i = n[o]
              ;(u = a[i.id]).refs--, r.push(u)
            }
            t && f(d(t, e), e)
            for (o = 0; o < r.length; o++) {
              var u
              if (0 === (u = r[o]).refs) {
                for (var c = 0; c < u.parts.length; c++) u.parts[c]()
                delete a[u.id]
              }
            }
          }
        )
      }
      var y,
        m =
          ((y = []),
          function(t, e) {
            return (y[t] = e), y.filter(Boolean).join('\n')
          })
      function k(t, e, n, r) {
        var o = n ? '' : r.css
        if (t.styleSheet) t.styleSheet.cssText = m(e, o)
        else {
          var a = document.createTextNode(o),
            i = t.childNodes
          i[e] && t.removeChild(i[e]), i.length ? t.insertBefore(a, i[e]) : t.appendChild(a)
        }
      }
    },
    function(t, e) {
      t.exports = function(t) {
        var e = 'undefined' != typeof window && window.location
        if (!e) throw new Error('fixUrls requires window.location')
        if (!t || 'string' != typeof t) return t
        var n = e.protocol + '//' + e.host,
          r = n + e.pathname.replace(/\/[^\/]*$/, '/')
        return t.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(t, e) {
          var o,
            a = e
              .trim()
              .replace(/^"(.*)"$/, function(t, e) {
                return e
              })
              .replace(/^'(.*)'$/, function(t, e) {
                return e
              })
          return /^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(a)
            ? t
            : ((o =
                0 === a.indexOf('//')
                  ? a
                  : 0 === a.indexOf('/')
                  ? n + a
                  : r + a.replace(/^\.\//, '')),
              'url(' + JSON.stringify(o) + ')')
        })
      }
    },
    function(t, e, n) {
      'use strict'
      function r(t, e, n) {
        return (
          e in t
            ? Object.defineProperty(t, e, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0,
              })
            : (t[e] = n),
          t
        )
      }
      function o(t) {
        if (
          Symbol.iterator in Object(t) ||
          '[object Arguments]' === Object.prototype.toString.call(t)
        )
          return Array.from(t)
      }
      function a(t) {
        return (
          (function(t) {
            if (Array.isArray(t)) {
              for (var e = 0, n = new Array(t.length); e < t.length; e++) n[e] = t[e]
              return n
            }
          })(t) ||
          o(t) ||
          (function() {
            throw new TypeError('Invalid attempt to spread non-iterable instance')
          })()
        )
      }
      function i(t) {
        return (
          (function(t) {
            if (Array.isArray(t)) return t
          })(t) ||
          o(t) ||
          (function() {
            throw new TypeError('Invalid attempt to destructure non-iterable instance')
          })()
        )
      }
      function u(t, e) {
        for (var n = 0; n < e.length; n++) {
          var r = e[n]
          ;(r.enumerable = r.enumerable || !1),
            (r.configurable = !0),
            'value' in r && (r.writable = !0),
            Object.defineProperty(t, r.key, r)
        }
      }
      function c(t) {
        return (c =
          'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
            ? function(t) {
                return typeof t
              }
            : function(t) {
                return t &&
                  'function' == typeof Symbol &&
                  t.constructor === Symbol &&
                  t !== Symbol.prototype
                  ? 'symbol'
                  : typeof t
              })(t)
      }
      function p(t) {
        return (p =
          'function' == typeof Symbol && 'symbol' === c(Symbol.iterator)
            ? function(t) {
                return c(t)
              }
            : function(t) {
                return t &&
                  'function' == typeof Symbol &&
                  t.constructor === Symbol &&
                  t !== Symbol.prototype
                  ? 'symbol'
                  : c(t)
              })(t)
      }
      function s(t) {
        if (void 0 === t)
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called")
        return t
      }
      function l(t) {
        return (l = Object.setPrototypeOf
          ? Object.getPrototypeOf
          : function(t) {
              return t.__proto__ || Object.getPrototypeOf(t)
            })(t)
      }
      function f(t, e) {
        return (f =
          Object.setPrototypeOf ||
          function(t, e) {
            return (t.__proto__ = e), t
          })(t, e)
      }
      n.r(e)
      var d,
        b = n(0),
        g = n.n(b),
        x = n(4),
        h = n.n(x),
        v = n(3),
        y = n.n(v),
        m = n(5),
        k = n.n(m),
        C = n(1),
        w = n.n(C),
        S =
          ('object' == typeof self && self.self === self && self) ||
          ('object' == typeof S && S.global === S && S) ||
          void 0,
        j = S.document || {}
      var P = {}
      function V(t, e, n) {
        e in P || (P[e] = [])
        var r = n || 0
        P[e][r] = t
      }
      var z = {
          allCountries: (d = []).concat.apply(
            d,
            a(
              [
                ['Afghanistan', ['asia'], 'af', '93'],
                ['Albania', ['europe'], 'al', '355'],
                ['Algeria', ['africa', 'north-africa'], 'dz', '213'],
                ['American Samoa', ['oceania'], 'as', '1684'],
                ['Andorra', ['europe'], 'ad', '376'],
                ['Angola', ['africa'], 'ao', '244'],
                ['Anguilla', ['america', 'carribean'], 'ai', '1264'],
                ['Antigua and Barbuda', ['america', 'carribean'], 'ag', '1268'],
                ['Argentina', ['america', 'south-america'], 'ar', '54', '+.. (..) ........'],
                ['Armenia', ['asia', 'ex-ussr'], 'am', '374'],
                ['Aruba', ['america', 'carribean'], 'aw', '297'],
                ['Australia', ['oceania'], 'au', '61', '+.. ... ... ...'],
                ['Austria', ['europe', 'european-union'], 'at', '43'],
                ['Azerbaijan', ['asia', 'ex-ussr'], 'az', '994'],
                ['Bahamas', ['america', 'carribean'], 'bs', '1242'],
                ['Bahrain', ['middle-east'], 'bh', '973'],
                ['Bangladesh', ['asia'], 'bd', '880'],
                ['Barbados', ['america', 'carribean'], 'bb', '1246'],
                ['Belarus', ['europe', 'ex-ussr'], 'by', '375', '+... (..) ... .. ..'],
                ['Belgium', ['europe', 'european-union'], 'be', '32', '+.. ... .. .. ..'],
                ['Belize', ['america', 'central-america'], 'bz', '501'],
                ['Benin', ['africa'], 'bj', '229'],
                ['Bermuda', ['america', 'north-america'], 'bm', '1441'],
                ['Bhutan', ['asia'], 'bt', '975'],
                ['Bolivia', ['america', 'south-america'], 'bo', '591'],
                ['Bosnia and Herzegovina', ['europe'], 'ba', '387'],
                ['Botswana', ['africa'], 'bw', '267'],
                ['Brazil', ['america', 'south-america'], 'br', '55', '+.. (..) .........'],
                ['British Indian Ocean Territory', ['asia'], 'io', '246'],
                ['British Virgin Islands', ['america', 'carribean'], 'vg', '1284'],
                ['Brunei', ['asia'], 'bn', '673'],
                ['Bulgaria', ['europe', 'european-union'], 'bg', '359'],
                ['Burkina Faso', ['africa'], 'bf', '226'],
                ['Burundi', ['africa'], 'bi', '257'],
                ['Cambodia', ['asia'], 'kh', '855'],
                ['Cameroon', ['africa'], 'cm', '237'],
                [
                  'Canada',
                  ['america', 'north-america'],
                  'ca',
                  '1',
                  '+. (...) ...-....',
                  1,
                  [
                    '204',
                    '236',
                    '249',
                    '250',
                    '289',
                    '306',
                    '343',
                    '365',
                    '387',
                    '403',
                    '416',
                    '418',
                    '431',
                    '437',
                    '438',
                    '450',
                    '506',
                    '514',
                    '519',
                    '548',
                    '579',
                    '581',
                    '587',
                    '604',
                    '613',
                    '639',
                    '647',
                    '672',
                    '705',
                    '709',
                    '742',
                    '778',
                    '780',
                    '782',
                    '807',
                    '819',
                    '825',
                    '867',
                    '873',
                    '902',
                    '905',
                  ],
                ],
                ['Cape Verde', ['africa'], 'cv', '238'],
                ['Caribbean Netherlands', ['america', 'carribean'], 'bq', '599', '', 1],
                ['Cayman Islands', ['america', 'carribean'], 'ky', '1345'],
                ['Central African Republic', ['africa'], 'cf', '236'],
                ['Chad', ['africa'], 'td', '235'],
                ['Chile', ['america', 'south-america'], 'cl', '56'],
                ['China', ['asia'], 'cn', '86', '+.. ..-.........'],
                ['Colombia', ['america', 'south-america'], 'co', '57'],
                ['Comoros', ['africa'], 'km', '269'],
                ['Congo', ['africa'], 'cd', '243'],
                ['Congo', ['africa'], 'cg', '242'],
                ['Cook Islands', ['oceania'], 'ck', '682'],
                ['Costa Rica', ['america', 'central-america'], 'cr', '506', '+... ....-....'],
                ['Côte d’Ivoire', ['africa'], 'ci', '225'],
                ['Croatia', ['europe', 'european-union'], 'hr', '385'],
                ['Cuba', ['america', 'carribean'], 'cu', '53'],
                ['Curaçao', ['america', 'carribean'], 'cw', '599', '', 0],
                ['Cyprus', ['europe', 'european-union'], 'cy', '357', '+... .. ......'],
                ['Czech Republic', ['europe', 'european-union'], 'cz', '420'],
                ['Denmark', ['europe', 'european-union'], 'dk', '45', '+.. .. .. .. ..'],
                ['Djibouti', ['africa'], 'dj', '253'],
                ['Dominica', ['america', 'carribean'], 'dm', '1767'],
                [
                  'Dominican Republic',
                  ['america', 'carribean'],
                  'do',
                  '1',
                  '',
                  2,
                  ['809', '829', '849'],
                ],
                ['Ecuador', ['america', 'south-america'], 'ec', '593'],
                ['Egypt', ['africa', 'north-africa'], 'eg', '20'],
                ['El Salvador', ['america', 'central-america'], 'sv', '503', '+... ....-....'],
                ['Equatorial Guinea', ['africa'], 'gq', '240'],
                ['Eritrea', ['africa'], 'er', '291'],
                [
                  'Estonia',
                  ['europe', 'european-union', 'ex-ussr'],
                  'ee',
                  '372',
                  '+... .... ......',
                ],
                ['Ethiopia', ['africa'], 'et', '251'],
                ['Falkland Islands', ['america', 'south-america'], 'fk', '500'],
                ['Faroe Islands', ['europe'], 'fo', '298'],
                ['Fiji', ['oceania'], 'fj', '679'],
                ['Finland', ['europe', 'european-union'], 'fi', '358', '+... .. ... .. ..'],
                ['France', ['europe', 'european-union'], 'fr', '33', '+.. . .. .. .. ..'],
                ['French Guiana', ['america', 'south-america'], 'gf', '594'],
                ['French Polynesia', ['oceania'], 'pf', '689'],
                ['Gabon', ['africa'], 'ga', '241'],
                ['Gambia', ['africa'], 'gm', '220'],
                ['Georgia', ['asia', 'ex-ussr'], 'ge', '995'],
                ['Germany', ['europe', 'european-union'], 'de', '49', '+.. .... ........'],
                ['Ghana', ['africa'], 'gh', '233'],
                ['Gibraltar', ['europe'], 'gi', '350'],
                ['Greece', ['europe', 'european-union'], 'gr', '30'],
                ['Greenland', ['america'], 'gl', '299'],
                ['Grenada', ['america', 'carribean'], 'gd', '1473'],
                ['Guadeloupe', ['america', 'carribean'], 'gp', '590', '', 0],
                ['Guam', ['oceania'], 'gu', '1671'],
                ['Guatemala', ['america', 'central-america'], 'gt', '502', '+... ....-....'],
                ['Guinea', ['africa'], 'gn', '224'],
                ['Guinea-Bissau', ['africa'], 'gw', '245'],
                ['Guyana', ['america', 'south-america'], 'gy', '592'],
                ['Haiti', ['america', 'carribean'], 'ht', '509', '+... ....-....'],
                ['Honduras', ['america', 'central-america'], 'hn', '504'],
                ['Hong Kong', ['asia'], 'hk', '852', '+... .... ....'],
                ['Hungary', ['europe', 'european-union'], 'hu', '36'],
                ['Iceland', ['europe'], 'is', '354', '+... ... ....'],
                ['India', ['asia'], 'in', '91', '+.. .....-.....'],
                ['Indonesia', ['asia'], 'id', '62'],
                ['Iran', ['middle-east'], 'ir', '98'],
                ['Iraq', ['middle-east'], 'iq', '964'],
                ['Ireland', ['europe', 'european-union'], 'ie', '353', '+... .. .......'],
                ['Israel', ['middle-east'], 'il', '972', '+... ... ... ....'],
                ['Italy', ['europe', 'european-union'], 'it', '39', '+.. ... .......', 0],
                ['Jamaica', ['america', 'carribean'], 'jm', '1876'],
                ['Japan', ['asia'], 'jp', '81', '+.. .. .... ....'],
                ['Jordan', ['middle-east'], 'jo', '962'],
                [
                  'Kazakhstan',
                  ['asia', 'ex-ussr'],
                  'kz',
                  '7',
                  '+. ... ...-..-..',
                  1,
                  [
                    '313',
                    '327',
                    '7172',
                    '312',
                    '73622',
                    '321',
                    '324',
                    '336',
                    '318',
                    '315',
                    '325',
                    '311',
                    '326',
                    '310',
                  ],
                ],
                ['Kenya', ['africa'], 'ke', '254'],
                ['Kiribati', ['oceania'], 'ki', '686'],
                ['Kuwait', ['middle-east'], 'kw', '965'],
                ['Kyrgyzstan', ['asia', 'ex-ussr'], 'kg', '996'],
                ['Laos', ['asia'], 'la', '856'],
                ['Latvia', ['europe', 'european-union', 'ex-ussr'], 'lv', '371'],
                ['Lebanon', ['middle-east'], 'lb', '961'],
                ['Lesotho', ['africa'], 'ls', '266'],
                ['Liberia', ['africa'], 'lr', '231'],
                ['Libya', ['africa', 'north-africa'], 'ly', '218'],
                ['Liechtenstein', ['europe'], 'li', '423'],
                ['Lithuania', ['europe', 'european-union', 'ex-ussr'], 'lt', '370'],
                ['Luxembourg', ['europe', 'european-union'], 'lu', '352'],
                ['Macau', ['asia'], 'mo', '853'],
                ['Macedonia', ['europe'], 'mk', '389'],
                ['Madagascar', ['africa'], 'mg', '261'],
                ['Malawi', ['africa'], 'mw', '265'],
                ['Malaysia', ['asia'], 'my', '60', '+.. ..-....-....'],
                ['Maldives', ['asia'], 'mv', '960'],
                ['Mali', ['africa'], 'ml', '223'],
                ['Malta', ['europe', 'european-union'], 'mt', '356'],
                ['Marshall Islands', ['oceania'], 'mh', '692'],
                ['Martinique', ['america', 'carribean'], 'mq', '596'],
                ['Mauritania', ['africa'], 'mr', '222'],
                ['Mauritius', ['africa'], 'mu', '230'],
                ['Mexico', ['america', 'central-america'], 'mx', '52'],
                ['Micronesia', ['oceania'], 'fm', '691'],
                ['Moldova', ['europe'], 'md', '373', '+... (..) ..-..-..'],
                ['Monaco', ['europe'], 'mc', '377'],
                ['Mongolia', ['asia'], 'mn', '976'],
                ['Montenegro', ['europe'], 'me', '382'],
                ['Montserrat', ['america', 'carribean'], 'ms', '1664'],
                ['Morocco', ['africa', 'north-africa'], 'ma', '212'],
                ['Mozambique', ['africa'], 'mz', '258'],
                ['Myanmar', ['asia'], 'mm', '95'],
                ['Namibia', ['africa'], 'na', '264'],
                ['Nauru', ['africa'], 'nr', '674'],
                ['Nepal', ['asia'], 'np', '977'],
                ['Netherlands', ['europe', 'european-union'], 'nl', '31', '+.. .. ........'],
                ['New Caledonia', ['oceania'], 'nc', '687'],
                ['New Zealand', ['oceania'], 'nz', '64', '+.. ...-...-....'],
                ['Nicaragua', ['america', 'central-america'], 'ni', '505'],
                ['Niger', ['africa'], 'ne', '227'],
                ['Nigeria', ['africa'], 'ng', '234'],
                ['Niue', ['asia'], 'nu', '683'],
                ['Norfolk Island', ['oceania'], 'nf', '672'],
                ['North Korea', ['asia'], 'kp', '850'],
                ['Northern Mariana Islands', ['oceania'], 'mp', '1670'],
                ['Norway', ['europe'], 'no', '47', '+.. ... .. ...'],
                ['Oman', ['middle-east'], 'om', '968'],
                ['Pakistan', ['asia'], 'pk', '92', '+.. ...-.......'],
                ['Palau', ['oceania'], 'pw', '680'],
                ['Palestine', ['middle-east'], 'ps', '970'],
                ['Panama', ['america', 'central-america'], 'pa', '507'],
                ['Papua New Guinea', ['oceania'], 'pg', '675'],
                ['Paraguay', ['america', 'south-america'], 'py', '595'],
                ['Peru', ['america', 'south-america'], 'pe', '51'],
                ['Philippines', ['asia'], 'ph', '63', '+.. .... .......'],
                ['Poland', ['europe', 'european-union'], 'pl', '48', '+.. ...-...-...'],
                ['Portugal', ['europe', 'european-union'], 'pt', '351'],
                ['Puerto Rico', ['america', 'carribean'], 'pr', '1', '', 3, ['787', '939']],
                ['Qatar', ['middle-east'], 'qa', '974'],
                ['Réunion', ['africa'], 're', '262'],
                ['Romania', ['europe', 'european-union'], 'ro', '40'],
                ['Russia', ['europe', 'asia', 'ex-ussr'], 'ru', '7', '+. (...) ...-..-..', 0],
                ['Rwanda', ['africa'], 'rw', '250'],
                ['Saint Barthélemy', ['america', 'carribean'], 'bl', '590', '', 1],
                ['Saint Helena', ['africa'], 'sh', '290'],
                ['Saint Kitts and Nevis', ['america', 'carribean'], 'kn', '1869'],
                ['Saint Lucia', ['america', 'carribean'], 'lc', '1758'],
                ['Saint Martin', ['america', 'carribean'], 'mf', '590', '', 2],
                ['Saint Pierre and Miquelon', ['america', 'north-america'], 'pm', '508'],
                ['Saint Vincent and the Grenadines', ['america', 'carribean'], 'vc', '1784'],
                ['Samoa', ['oceania'], 'ws', '685'],
                ['San Marino', ['europe'], 'sm', '378'],
                ['São Tomé and Príncipe', ['africa'], 'st', '239'],
                ['Saudi Arabia', ['middle-east'], 'sa', '966'],
                ['Senegal', ['africa'], 'sn', '221'],
                ['Serbia', ['europe'], 'rs', '381'],
                ['Seychelles', ['africa'], 'sc', '248'],
                ['Sierra Leone', ['africa'], 'sl', '232'],
                ['Singapore', ['asia'], 'sg', '65', '+.. ....-....'],
                ['Sint Maarten', ['america', 'carribean'], 'sx', '1721'],
                ['Slovakia', ['europe', 'european-union'], 'sk', '421'],
                ['Slovenia', ['europe', 'european-union'], 'si', '386'],
                ['Solomon Islands', ['oceania'], 'sb', '677'],
                ['Somalia', ['africa'], 'so', '252'],
                ['South Africa', ['africa'], 'za', '27'],
                ['South Korea', ['asia'], 'kr', '82', '+.. ... .... ....'],
                ['South Sudan', ['africa', 'north-africa'], 'ss', '211'],
                ['Spain', ['europe', 'european-union'], 'es', '34', '+.. ... ... ...'],
                ['Sri Lanka', ['asia'], 'lk', '94'],
                ['Sudan', ['africa'], 'sd', '249'],
                ['Suriname', ['america', 'south-america'], 'sr', '597'],
                ['Swaziland', ['africa'], 'sz', '268'],
                ['Sweden', ['europe', 'european-union'], 'se', '46', '+.. (...) ...-...'],
                ['Switzerland', ['europe'], 'ch', '41', '+.. .. ... .. ..'],
                ['Syria', ['middle-east'], 'sy', '963'],
                ['Taiwan', ['asia'], 'tw', '886'],
                ['Tajikistan', ['asia', 'ex-ussr'], 'tj', '992'],
                ['Tanzania', ['africa'], 'tz', '255'],
                ['Thailand', ['asia'], 'th', '66'],
                ['Timor-Leste', ['asia'], 'tl', '670'],
                ['Togo', ['africa'], 'tg', '228'],
                ['Tokelau', ['oceania'], 'tk', '690'],
                ['Tonga', ['oceania'], 'to', '676'],
                ['Trinidad and Tobago', ['america', 'carribean'], 'tt', '1868'],
                ['Tunisia', ['africa', 'north-africa'], 'tn', '216'],
                ['Turkey', ['europe'], 'tr', '90', '+.. ... ... .. ..'],
                ['Turkmenistan', ['asia', 'ex-ussr'], 'tm', '993'],
                ['Turks and Caicos Islands', ['america', 'carribean'], 'tc', '1649'],
                ['Tuvalu', ['asia'], 'tv', '688'],
                ['U.S. Virgin Islands', ['america', 'carribean'], 'vi', '1340'],
                ['Uganda', ['africa'], 'ug', '256'],
                ['Ukraine', ['europe', 'ex-ussr'], 'ua', '380', '+... (..) ... .. ..'],
                ['United Arab Emirates', ['middle-east'], 'ae', '971'],
                ['United Kingdom', ['europe', 'european-union'], 'gb', '44', '+.. .... ......'],
                [
                  'United States',
                  ['america', 'north-america'],
                  'us',
                  '1',
                  '+. (...) ...-....',
                  0,
                  [
                    '907',
                    '205',
                    '251',
                    '256',
                    '334',
                    '479',
                    '501',
                    '870',
                    '480',
                    '520',
                    '602',
                    '623',
                    '928',
                    '209',
                    '213',
                    '310',
                    '323',
                    '408',
                    '415',
                    '510',
                    '530',
                    '559',
                    '562',
                    '619',
                    '626',
                    '650',
                    '661',
                    '707',
                    '714',
                    '760',
                    '805',
                    '818',
                    '831',
                    '858',
                    '909',
                    '916',
                    '925',
                    '949',
                    '951',
                    '303',
                    '719',
                    '970',
                    '203',
                    '860',
                    '202',
                    '302',
                    '239',
                    '305',
                    '321',
                    '352',
                    '386',
                    '407',
                    '561',
                    '727',
                    '772',
                    '813',
                    '850',
                    '863',
                    '904',
                    '941',
                    '954',
                    '229',
                    '404',
                    '478',
                    '706',
                    '770',
                    '912',
                    '808',
                    '319',
                    '515',
                    '563',
                    '641',
                    '712',
                    '208',
                    '217',
                    '309',
                    '312',
                    '618',
                    '630',
                    '708',
                    '773',
                    '815',
                    '847',
                    '219',
                    '260',
                    '317',
                    '574',
                    '765',
                    '812',
                    '316',
                    '620',
                    '785',
                    '913',
                    '270',
                    '502',
                    '606',
                    '859',
                    '225',
                    '318',
                    '337',
                    '504',
                    '985',
                    '413',
                    '508',
                    '617',
                    '781',
                    '978',
                    '301',
                    '410',
                    '207',
                    '231',
                    '248',
                    '269',
                    '313',
                    '517',
                    '586',
                    '616',
                    '734',
                    '810',
                    '906',
                    '989',
                    '218',
                    '320',
                    '507',
                    '612',
                    '651',
                    '763',
                    '952',
                    '314',
                    '417',
                    '573',
                    '636',
                    '660',
                    '816',
                    '228',
                    '601',
                    '662',
                    '406',
                    '252',
                    '336',
                    '704',
                    '828',
                    '910',
                    '919',
                    '701',
                    '308',
                    '402',
                    '603',
                    '201',
                    '609',
                    '732',
                    '856',
                    '908',
                    '973',
                    '505',
                    '575',
                    '702',
                    '775',
                    '212',
                    '315',
                    '516',
                    '518',
                    '585',
                    '607',
                    '631',
                    '716',
                    '718',
                    '845',
                    '914',
                    '216',
                    '330',
                    '419',
                    '440',
                    '513',
                    '614',
                    '740',
                    '937',
                    '405',
                    '580',
                    '918',
                    '503',
                    '541',
                    '215',
                    '412',
                    '570',
                    '610',
                    '717',
                    '724',
                    '814',
                    '401',
                    '803',
                    '843',
                    '864',
                    '605',
                    '423',
                    '615',
                    '731',
                    '865',
                    '901',
                    '931',
                    '210',
                    '214',
                    '254',
                    '281',
                    '325',
                    '361',
                    '409',
                    '432',
                    '512',
                    '713',
                    '806',
                    '817',
                    '830',
                    '903',
                    '915',
                    '936',
                    '940',
                    '956',
                    '972',
                    '979',
                    '435',
                    '801',
                    '276',
                    '434',
                    '540',
                    '703',
                    '757',
                    '804',
                    '802',
                    '206',
                    '253',
                    '360',
                    '425',
                    '509',
                    '262',
                    '414',
                    '608',
                    '715',
                    '920',
                    '304',
                    '307',
                  ],
                ],
                ['Uruguay', ['america', 'south-america'], 'uy', '598'],
                ['Uzbekistan', ['asia', 'ex-ussr'], 'uz', '998'],
                ['Vanuatu', ['oceania'], 'vu', '678'],
                ['Vatican City', ['europe'], 'va', '39', '+.. .. .... ....', 1],
                ['Venezuela', ['america', 'south-america'], 've', '58'],
                ['Vietnam', ['asia'], 'vn', '84'],
                ['Wallis and Futuna', ['oceania'], 'wf', '681'],
                ['Yemen', ['middle-east'], 'ye', '967'],
                ['Zambia', ['africa'], 'zm', '260'],
                ['Zimbabwe', ['africa'], 'zw', '263'],
              ].map(function(t) {
                var e = {
                    name: t[0],
                    regions: t[1],
                    iso2: t[2],
                    dialCode: t[3],
                    format: t[4] || void 0,
                    priority: t[5] || 0,
                    hasAreaCodes: !!t[6],
                  },
                  n = []
                return (
                  t[6] &&
                    t[6].map(function(o) {
                      var a = (function(t) {
                        for (var e = 1; e < arguments.length; e++) {
                          var n = null != arguments[e] ? arguments[e] : {},
                            o = Object.keys(n)
                          'function' == typeof Object.getOwnPropertySymbols &&
                            (o = o.concat(
                              Object.getOwnPropertySymbols(n).filter(function(t) {
                                return Object.getOwnPropertyDescriptor(n, t).enumerable
                              })
                            )),
                            o.forEach(function(e) {
                              r(t, e, n[e])
                            })
                        }
                        return t
                      })({}, e)
                      ;(a.regions = t[1]),
                        (a.dialCode = t[3] + o),
                        (a.isAreaCode = !0),
                        n.push(a),
                        V(t[2], a.dialCode)
                    }),
                  V(e.iso2, e.dialCode, e.hasAreaCodes),
                  n.length > 0 ? [e].concat(n) : [e]
                )
              })
            )
          ),
          allCountryCodes: P,
        },
        F =
          (n(7),
          (function(t) {
            function e(t) {
              var n, o, u
              !(function(t, e) {
                if (!(t instanceof e)) throw new TypeError('Cannot call a class as a function')
              })(this, e),
                (o = this),
                (u = l(e).call(this, t)),
                ((n =
                  !u || ('object' !== p(u) && 'function' != typeof u)
                    ? s(o)
                    : u).deleteAreaCodes = function(t) {
                  return t.filter(function(t) {
                    return !0 !== t.isAreaCode
                  })
                }),
                (n.filterRegions = function(t, e) {
                  if ('string' == typeof t) {
                    var n = t
                    return e.filter(function(t) {
                      return t.regions.some(function(t) {
                        return t === n
                      })
                    })
                  }
                  return e.filter(function(e) {
                    return t
                      .map(function(t) {
                        return e.regions.some(function(e) {
                          return e === t
                        })
                      })
                      .some(function(t) {
                        return t
                      })
                  })
                }),
                (n.insertMasks = function(t, e) {
                  var n = function(n) {
                    var r = e.findIndex(function(t) {
                      return t.iso2 == n
                    })
                    ;-1 != r && (e[r].format = t[n])
                  }
                  for (var r in t) n(r)
                  return e
                }),
                (n.getOnlyCountries = function(t, e) {
                  return 0 === t.length
                    ? e
                    : e.filter(function(e) {
                        return t.some(function(t) {
                          return t === e.iso2
                        })
                      })
                }),
                (n.excludeCountries = function(t, e) {
                  return 0 === e.length
                    ? t
                    : t.filter(function(t) {
                        return !e.includes(t.iso2)
                      })
                }),
                (n.getProbableCandidate = y()(function(t) {
                  return t && 0 !== t.length
                    ? n.state.onlyCountries.filter(function(e) {
                        return e.name.toLowerCase().startsWith(t.toLowerCase())
                      }, s(s(n)))[0]
                    : null
                })),
                (n.guessSelectedCountry = y()(function(t, e, r) {
                  var o =
                    e.find(function(t) {
                      return t.iso2 == r
                    }) || {}
                  if ('' === t.trim()) return o
                  var a = e.reduce(
                    function(e, n) {
                      if (t.startsWith(n.dialCode)) {
                        if (n.dialCode.length > e.dialCode.length) return n
                        if (n.dialCode.length === e.dialCode.length && n.priority < e.priority)
                          return n
                      }
                      return e
                    },
                    { dialCode: '', priority: 10001 },
                    s(s(n))
                  )
                  return a.name ? a : o
                })),
                (n.updateDefaultCountry = function(t) {
                  var e = n.state.onlyCountries.find(function(e) {
                    return e.iso2 == t
                  })
                  n.setState({
                    defaultCountry: t,
                    selectedCountry: e,
                    formattedNumber: n.props.disableCountryCode ? '' : '+' + e.dialCode,
                  })
                }),
                (n.scrollTo = function(t, e) {
                  if (t) {
                    var r = n.dropdownRef
                    if (r && j.body) {
                      var o = r.offsetHeight,
                        a = r.getBoundingClientRect().top + j.body.scrollTop,
                        i = a + o,
                        u = t,
                        c = u.getBoundingClientRect(),
                        p = u.offsetHeight,
                        s = c.top + j.body.scrollTop,
                        l = s + p,
                        f = s - a + r.scrollTop,
                        d = o / 2 - p / 2
                      if (s < a) e && (f -= d), (r.scrollTop = f)
                      else if (l > i) {
                        e && (f += d)
                        var b = o - p
                        r.scrollTop = f - b
                      }
                    }
                  }
                }),
                (n.formatNumber = function(t, e) {
                  var r,
                    o = n.props,
                    a = o.disableCountryCode,
                    u = o.enableLongNumbers,
                    c = o.autoFormat
                  if (
                    (a && e ? ((r = e.split(' ')).shift(), (r = r.join(' '))) : (r = e),
                    !t || 0 === t.length)
                  )
                    return a ? '' : '+'
                  if ((t && t.length < 2) || !r || !c) return a ? t : '+'.concat(t)
                  var p,
                    s = k()(
                      r,
                      function(t, e) {
                        if (0 === t.remainingText.length) return t
                        if ('.' !== e)
                          return {
                            formattedText: t.formattedText + e,
                            remainingText: t.remainingText,
                          }
                        var n = i(t.remainingText),
                          r = n[0],
                          o = n.slice(1)
                        return { formattedText: t.formattedText + r, remainingText: o }
                      },
                      { formattedText: '', remainingText: t.split('') }
                    )
                  return (
                    (p = u ? s.formattedText + s.remainingText.join('') : s.formattedText).includes(
                      '('
                    ) &&
                      !p.includes(')') &&
                      (p += ')'),
                    p
                  )
                }),
                (n.cursorToEnd = function() {
                  var t = n.numberInputRef
                  t.focus()
                  var e = t.value.length
                  t.setSelectionRange(e, e)
                }),
                (n.getElement = function(t) {
                  return n['flag_no_'.concat(t)]
                }),
                (n.getCountryData = function() {
                  return n.state.selectedCountry
                    ? {
                        name: n.state.selectedCountry.name || '',
                        dialCode: n.state.selectedCountry.dialCode || '',
                        countryCode: n.state.selectedCountry.iso2 || '',
                      }
                    : {}
                }),
                (n.handleFlagDropdownClick = function() {
                  if (n.state.showDropdown || !n.props.disabled)
                    if (n.state.preferredCountries.includes(n.state.selectedCountry))
                      n.setState(
                        {
                          showDropdown: !n.state.showDropdown,
                          highlightCountryIndex: n.state.preferredCountries.findIndex(function(t) {
                            return t == n.state.selectedCountry
                          }),
                        },
                        function() {
                          n.state.showDropdown &&
                            n.scrollTo(n.getElement(n.state.highlightCountryIndex))
                        }
                      )
                    else {
                      var t = n.props.disableAreaCodes
                        ? n.deleteAreaCodes(n.state.onlyCountries)
                        : n.state.onlyCountries
                      n.setState(
                        {
                          showDropdown: !n.state.showDropdown,
                          highlightCountryIndex: n.props.disableAreaCodes
                            ? t.findIndex(function(t) {
                                return t.iso2 == n.state.selectedCountry.iso2
                              })
                            : t.findIndex(function(t) {
                                return t == n.state.selectedCountry
                              }),
                        },
                        function() {
                          n.state.showDropdown &&
                            n.scrollTo(
                              n.getElement(
                                n.state.highlightCountryIndex + n.state.preferredCountries.length
                              )
                            )
                        }
                      )
                    }
                }),
                (n.handleInput = function(t) {
                  var e = n.props.disableCountryCode ? '' : '+',
                    r = n.state.selectedCountry,
                    o = n.state.freezeSelection
                  if (!n.props.countryCodeEditable) {
                    var a = '+' + r.dialCode
                    if (t.target.value.length < a.length) return
                  }
                  if (
                    !(t.target.value.replace(/\D/g, '').length > 15) &&
                    t.target.value !== n.state.formattedNumber
                  ) {
                    if (
                      (t.preventDefault ? t.preventDefault() : (t.returnValue = !1),
                      t.target.value.length > 0)
                    ) {
                      var i = t.target.value.replace(/\D/g, '')
                      ;(!n.state.freezeSelection ||
                        n.state.selectedCountry.dialCode.length > i.length) &&
                        ((r = n.guessSelectedCountry(
                          i.substring(0, 6),
                          n.state.onlyCountries,
                          n.state.defaultCountry
                        )),
                        (o = !1)),
                        (e = n.formatNumber(i, r.format))
                    }
                    var u = t.target.selectionStart,
                      c = n.state.formattedNumber,
                      p = e.length - c.length
                    n.setState(
                      {
                        formattedNumber: e,
                        freezeSelection: o,
                        selectedCountry: r.dialCode ? r : n.state.selectedCountry,
                      },
                      function() {
                        p > 0 && (u -= p),
                          ')' == e.charAt(e.length - 1)
                            ? n.numberInputRef.setSelectionRange(e.length - 1, e.length - 1)
                            : u > 0 &&
                              c.length >= e.length &&
                              n.numberInputRef.setSelectionRange(u, u),
                          n.props.onChange &&
                            n.props.onChange(n.state.formattedNumber, n.getCountryData())
                      }
                    )
                  }
                }),
                (n.handleInputClick = function(t) {
                  n.setState({ showDropdown: !1 }),
                    n.props.onClick && n.props.onClick(t, n.getCountryData())
                }),
                (n.handleFlagItemClick = function(t) {
                  var e = n.state.selectedCountry,
                    r = n.state.onlyCountries.find(function(e) {
                      return e == t
                    }),
                    o = n.state.formattedNumber
                      .replace(' ', '')
                      .replace('(', '')
                      .replace(')', '')
                      .replace('-', ''),
                    a = o.length > 1 ? o.replace(e.dialCode, r.dialCode) : r.dialCode,
                    i = n.formatNumber(a.replace(/\D/g, ''), r.format)
                  n.setState(
                    {
                      showDropdown: !1,
                      selectedCountry: r,
                      freezeSelection: !0,
                      formattedNumber: i,
                    },
                    function() {
                      n.cursorToEnd(), n.props.onChange && n.props.onChange(i, n.getCountryData())
                    }
                  )
                }),
                (n.handleInputFocus = function(t) {
                  n.setState(
                    {focus: true}
                  )
                  n.numberInputRef &&
                    '+' === n.numberInputRef.value &&
                    n.state.selectedCountry &&
                    !n.props.disableCountryCode &&
                    n.setState(
                      { formattedNumber: '+' + n.state.selectedCountry.dialCode },
                      function() {
                        return setTimeout(n.cursorToEnd, 10)
                      }
                    ),
                    n.setState({ placeholder: '' }),
                    n.props.onFocus && n.props.onFocus(t, n.getCountryData()),
                    setTimeout(n.cursorToEnd, 10)
                }),
                (n.handleInputBlur = function(t) {
                  n.setState(
                    {focus: false}
                  )
                  t.target.value || n.setState({ placeholder: n.props.placeholder }),
                    n.props.onBlur && n.props.onBlur(t, n.getCountryData())
                }),
                (n.getHighlightCountryIndex = function(t) {
                  var e = n.state.highlightCountryIndex + t
                  return e < 0 ||
                    e >= n.state.onlyCountries.length + n.state.preferredCountries.length
                    ? e - t
                    : e
                }),
                (n.searchCountry = function() {
                  var t = n.getProbableCandidate(n.state.queryString) || n.state.onlyCountries[0],
                    e =
                      n.state.onlyCountries.findIndex(function(e) {
                        return e == t
                      }) + n.state.preferredCountries.length
                  n.scrollTo(n.getElement(e), !0),
                    n.setState({ queryString: '', highlightCountryIndex: e })
                }),
                (n.handleKeydown = function(t) {
                  var e = n.props.keys
                  if (n.state.showDropdown && !n.props.disabled && 'search-box' !== t.target.id) {
                    t.preventDefault ? t.preventDefault() : (t.returnValue = !1)
                    var r = function(t) {
                      n.setState(
                        { highlightCountryIndex: n.getHighlightCountryIndex(t) },
                        function() {
                          n.scrollTo(
                            n.getElement(
                              n.state.highlightCountryIndex + n.state.preferredCountries.length
                            ),
                            !0
                          )
                        }
                      )
                    }
                    switch (t.which) {
                      case e.DOWN:
                        r(1)
                        break
                      case e.UP:
                        r(-1)
                        break
                      case e.ENTER:
                        n.handleFlagItemClick(
                          n.state.onlyCountries[n.state.highlightCountryIndex],
                          t
                        )
                        break
                      case e.ESC:
                        n.setState({ showDropdown: !1 }, n.cursorToEnd)
                        break
                      default:
                        ;((t.which >= e.A && t.which <= e.Z) || t.which === e.SPACE) &&
                          n.setState(
                            { queryString: n.state.queryString + String.fromCharCode(t.which) },
                            n.state.debouncedQueryStingSearcher
                          )
                    }
                  }
                }),
                (n.handleInputKeyDown = function(t) {
                  var e = n.props.keys
                  t.which === e.ENTER && n.props.onEnterKeyPress(t),
                    n.props.onKeyDown && n.props.onKeyDown(t)
                }),
                (n.handleClickOutside = function(t) {
                  n.dropdownRef &&
                    !n.dropdownContainerRef.contains(t.target) &&
                    n.state.showDropdown &&
                    n.setState({ showDropdown: !1 })
                }),
                (n.handleSearchChange = function(t) {
                  var e = t.currentTarget.value
                  n.setState({ searchValue: e })
                }),
                (n.getDropdownCountryName = function(t) {
                  return null != n.props.localization[t.name]
                    ? n.props.localization[t.name]
                    : null != n.props.localization[t.iso2]
                    ? n.props.localization[t.iso2]
                    : t.name
                }),
                (n.getCountryDropdownList = function() {
                  var t,
                    e = n.state,
                    o = e.preferredCountries,
                    i = e.onlyCountries,
                    u = e.highlightCountryIndex,
                    c = e.showDropdown,
                    p = e.searchValue,
                    s = n.props,
                    l = s.enableSearchField,
                    f = s.searchClass,
                    d = n.state.preferredCountries.includes(n.state.selectedCountry),
                    b = o.concat(i),
                    x = p.trim().toLowerCase(),
                    h =
                      l && x
                        ? a(
                            new Set(
                              b.filter(function(t) {
                                var e = t.name,
                                  n = t.iso2,
                                  r = t.dialCode
                                return [''.concat(e), ''.concat(n), '+'.concat(r)].some(function(
                                  t
                                ) {
                                  return t.toLowerCase().includes(x)
                                })
                              })
                            )
                          )
                        : b
                  n.props.disableAreaCodes && (h = n.deleteAreaCodes(h))
                  var v = h.map(function(t, e) {
                      var r = w()({
                          country: !0,
                          preferred: 'us' === t.iso2 || 'gb' === t.iso2,
                          active: 'us' === t.iso2,
                          highlight: d ? u === e : u === e - o.length,
                        }),
                        a = 'flag '.concat(t.iso2)
                      return g.a.createElement(
                        'li',
                        {
                          ref: function(t) {
                            return (n['flag_no_'.concat(e)] = t)
                          },
                          key: 'flag_no_'.concat(e),
                          'data-flag-key': 'flag_no_'.concat(e),
                          className: r,
                          'data-dial-code': '1',
                          'data-country-code': t.iso2,
                          onClick: function() {
                            return n.handleFlagItemClick(t)
                          },
                        },
                        g.a.createElement('div', { className: a }),
                        g.a.createElement(
                          'span',
                          { className: 'country-name' },
                          n.getDropdownCountryName(t)
                        ),
                        g.a.createElement('span', { className: 'dial-code' }, '+' + t.dialCode)
                      )
                    }),
                    y = g.a.createElement('li', { key: 'dashes', className: 'divider' })
                  o.length > 0 && v.splice(o.length, 0, y)
                  var m = w()(
                    (r((t = {}), n.props.dropdownClass, !0),
                    r(t, 'country-list', !0),
                    r(t, 'hide', !c),
                    t)
                  )
                  return g.a.createElement(
                    'ul',
                    {
                      ref: function(t) {
                        return (n.dropdownRef = t)
                      },
                      className: m,
                      style: n.props.dropdownStyle,
                    },
                    l &&
                      g.a.createElement(
                        'li',
                        { className: w()(r({ search: !0 }, f, f)) },
                        g.a.createElement(
                          'label',
                          null,
                          g.a.createElement(
                            'span',
                            {
                              className: w()(r({ 'search-emoji': !0 }, ''.concat(f, '-emoji'), f)),
                              role: 'img',
                              'aria-label': 'Magnifying glass',
                            },
                            '🔎'
                          ),
                          g.a.createElement('input', {
                            className: w()(r({ 'search-box': !0 }, ''.concat(f, '-box'), f)),
                            id: 'search-box',
                            type: 'search',
                            placeholder: n.props.searchPlaceholder,
                            autoFocus: !0,
                            value: p,
                            onChange: n.handleSearchChange,
                          })
                        )
                      ),
                    v.length > 0
                      ? v
                      : g.a.createElement(
                          'li',
                          { className: 'no-entries-message' },
                          g.a.createElement('span', null, 'No entries to show.')
                        )
                  )
                })
              var c = z.allCountries
              t.regions && (c = n.filterRegions(t.regions, c)),
                0 !== Object.keys(t.masks).length && (c = n.insertMasks(t.masks, c))
              var f,
                d = n.excludeCountries(n.getOnlyCountries(t.onlyCountries, c), t.excludeCountries),
                b = c.filter(function(e) {
                  return t.preferredCountries.some(function(t) {
                    return t === e.iso2
                  })
                }),
                x = t.value.replace(/[^0-9\.]+/g, '') || ''
              f =
                x.length > 1
                  ? n.guessSelectedCountry(x.substring(0, 6), d, t.defaultCountry) || 0
                  : (t.defaultCountry &&
                      d.find(function(e) {
                        return e.iso2 == t.defaultCountry
                      })) ||
                    0
              var v,
                m =
                  x.length < 2 && f && !x.replace(/\D/g, '').startsWith(f.dialCode)
                    ? f.dialCode
                    : ''
              v =
                '' === x && 0 === f
                  ? ''
                  : n.formatNumber(
                      (t.disableCountryCode ? '' : m) + x.replace(/\D/g, ''),
                      f.name ? f.format : void 0
                    )
              var C = c.findIndex(function(t) {
                return t == f
              })
              return (
                (n.state = {
                  focus: false,
                  formattedNumber: v,
                  onlyCountries: d,
                  preferredCountries: b,
                  defaultCountry: t.defaultCountry,
                  selectedCountry: f,
                  highlightCountryIndex: C,
                  queryString: '',
                  showDropdown: !1,
                  freezeSelection: !1,
                  debouncedQueryStingSearcher: h()(n.searchCountry, 250),
                  searchValue: '',
                }),
                n
              )
            }
            var n, o, c
            return (
              (function(t, e) {
                if ('function' != typeof e && null !== e)
                  throw new TypeError('Super expression must either be null or a function')
                ;(t.prototype = Object.create(e && e.prototype, {
                  constructor: { value: t, writable: !0, configurable: !0 },
                })),
                  e && f(t, e)
              })(e, g.a.Component),
              (n = e),
              (o = [
                {
                  key: 'componentDidMount',
                  value: function() {
                    j.addEventListener &&
                      (j.addEventListener('mousedown', this.handleClickOutside),
                      j.addEventListener('keydown', this.handleKeydown))
                  },
                },
                {
                  key: 'componentWillUnmount',
                  value: function() {
                    j.removeEventListener &&
                      (j.removeEventListener('mousedown', this.handleClickOutside),
                      j.removeEventListener('keydown', this.handleKeydown))
                  },
                },
                {
                  key: 'componentWillReceiveProps',
                  value: function(t) {
                    t.defaultCountry &&
                      t.defaultCountry !== this.state.defaultCountry &&
                      this.updateDefaultCountry(t.defaultCountry),
                      t.value !== this.state.formattedNumber && this.updateFormattedNumber(t.value)
                  },
                },
                {
                  key: 'updateFormattedNumber',
                  value: function(t) {
                    var e,
                      n = this.state,
                      r = n.onlyCountries,
                      o = n.defaultCountry,
                      a = t,
                      i = t
                    if (a.startsWith('+'))
                      (a = a.replace(/\D/g, '')),
                        (e = this.guessSelectedCountry(a.substring(0, 6), r, o)),
                        (i = this.formatNumber(a, e.format))
                    else {
                      var u =
                        (e = r.find(function(t) {
                          return t.iso2 == o
                        })) && !a.replace(/\D/g, '').startsWith(e.dialCode)
                          ? e.dialCode
                          : ''
                      i = this.formatNumber(
                        (this.props.disableCountryCode ? '' : u) + a.replace(/\D/g, ''),
                        e ? e.format : void 0
                      )
                    }
                    this.setState({ selectedCountry: e, formattedNumber: i })
                  },
                },
                {
                  key: 'render',
                  value: function() {
                    var t,
                      e,
                      n = this,
                      o = this.state,
                      a = o.selectedCountry,
                      i = o.showDropdown,
                      u = o.formattedNumber,
                      c = this.props.disableDropdown,
                      p = w()({ arrow: !0, up: i }),
                      s = w()(
                        (r((t = {}), this.props.inputClass, !0),
                        r(t, 'form-control', !0),
                        r(t, 'invalid-number', !this.props.isValid(u.replace(/\D/g, ''))),
                        t)
                      ),
                      l = w()(
                        (r((e = {}), this.props.buttonClass, !0),
                        r(e, 'flag-dropdown', !0),
                        r(e, 'open-dropdown', i),
                        e)
                      ),
                      f = 'flag '.concat(a.iso2)
                    return g.a.createElement(
                      'div',
                      { className: `${this.props.containerClass} ${this.state.showDropdown ? 'is-opened' : ''} ${this.state.focus ? 'focused' : ''}`, style: this.props.containerStyle },
                      g.a.createElement(
                        'input',
                        Object.assign(
                          {
                            className: s,
                            style: this.props.inputStyle,
                            onChange: this.handleInput,
                            onClick: this.handleInputClick,
                            onFocus: this.handleInputFocus,
                            onBlur: this.handleInputBlur,
                            value: u,
                            ref: function(t) {
                              return (n.numberInputRef = t)
                            },
                            onKeyDown: this.handleInputKeyDown,
                            placeholder: this.props.placeholder,
                            disabled: this.props.disabled,
                            type: 'tel',
                          },
                          this.props.inputExtraProps
                        )
                      ),
                      g.a.createElement(
                        'div',
                        {
                          className: l,
                          style: this.props.buttonStyle,
                          onKeyDown: this.handleKeydown,
                          ref: function(t) {
                            return (n.dropdownContainerRef = t)
                          },
                        },
                        g.a.createElement(
                          'div',
                          {
                            onClick: c ? void 0 : this.handleFlagDropdownClick,
                            className: 'selected-flag',
                            title: a ? ''.concat(a.name, ': + ').concat(a.dialCode) : '',
                          },
                          g.a.createElement(
                            'div',
                            { className: f },
                            !c && g.a.createElement('div', { className: p })
                          )
                        ),
                        i && this.getCountryDropdownList()
                      )
                    )
                  },
                },
              ]) && u(n.prototype, o),
              c && u(n, c),
              e
            )
          })())
      F.defaultProps = {
        excludeCountries: [],
        onlyCountries: [],
        preferredCountries: [],
        defaultCountry: '',
        value: '',
        placeholder: '+1 (702) 123-4567',
        searchPlaceholder: 'search',
        flagsImagePath: './flags.png',
        disabled: !1,
        containerStyle: {},
        inputStyle: {},
        buttonStyle: {},
        dropdownStyle: {},
        containerClass: 'react-tel-input',
        inputClass: '',
        buttonClass: '',
        dropdownClass: '',
        searchClass: '',
        autoFormat: !0,
        disableAreaCodes: !1,
        isValid: function(t) {
          return z.allCountries.some(function(e) {
            return t.startsWith(e.dialCode) || e.dialCode.startsWith(t)
          })
        },
        disableCountryCode: !1,
        disableDropdown: !1,
        enableLongNumbers: !1,
        countryCodeEditable: !0,
        enableSearchField: !1,
        regions: '',
        inputExtraProps: {},
        localization: {},
        masks: {},
        onEnterKeyPress: function() {},
        keys: {
          UP: 38,
          DOWN: 40,
          RIGHT: 39,
          LEFT: 37,
          ENTER: 13,
          ESC: 27,
          PLUS: 43,
          A: 65,
          Z: 90,
          SPACE: 32,
        },
      }
      e.default = F
    },
  ])
})
